import { LandingPageConfig } from 'rangeConfig/@types';
import kallaxBgImage from '../../views/LandingPage/images/kallax_landing_bg.jpg';
import kallaxDesignFromScratch from '../../views/LandingPage/images/designFromScratch.jpg';
import kallaxBrowseInspirationImg from '../../views/LandingPage/images/kallax_browse_inspiration.png';
import kallaxGalleryConfig from './kallaxGalleryConfig';

const kallaxLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: kallaxBgImage,
    titleTextColor: '#111111'
  },
  designFromScratch: {
    backgroundColor: '#D8D4BD',
    backgroundImgUrl: kallaxDesignFromScratch
  },
  openDesign: {
    backgroundColor: '#373B3E',
    backgroundImgUrl: kallaxBrowseInspirationImg,
    textColor: '#FFFFFF'
  },
  browseInspiration: {
    backgroundColor: '#9FB0A7',
    backgroundImgUrl: kallaxBrowseInspirationImg,
    galleryConfig: kallaxGalleryConfig
  }
};

export default kallaxLandingPageConfig;
